"use client";

import React from "react";
import Image from "next/image";
import "./ProjectHeroInfo.css";
import { motion } from "framer-motion";

export default function ProjectHeroInfo({ projectDetail, staticProjectDetail }) {
  if (!projectDetail) return null;
  console.log("",staticProjectDetail)
  return (
    <section className="project-hero-info section-padding">
      <div className="mini-container">
        <motion.div
          className="project-hero-content"
          initial={{ opacity: 0, y: 40 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.7, ease: "easeOut" }}
          viewport={{ once: true }}
        >
          {/* Logo / Title */}
          {projectDetail?.project_logo_full ? (
            <motion.div
              className="project-logo"
              initial={{ opacity: 0 }}
              whileInView={{ opacity: 1 }}
              transition={{ duration: 0.6, delay: 0.2 }}
              viewport={{ once: true }}
            >
              <Image
                src={projectDetail.project_logo_full}
                alt={projectDetail.project_title}
                width={180}
                height={140}
                priority
                className="logo-img"
              />
            </motion.div>
          ) : (
            <motion.div
              className="banner-title"
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.6, delay: 0.2 }}
              viewport={{ once: true }}
            >
              <h1>{projectDetail?.project_title || "Project"}</h1>
            </motion.div>
          )}

          {/* Meta */}
          <motion.div
            className="project-metastrip"
            initial="hidden"
            whileInView="visible"
            viewport={{ once: true }}
            variants={{
              hidden: {},
              visible: {
                transition: {
                  staggerChildren: 0.15,
                },
              },
            }}
          >
            {projectDetail?.size_price && (
              <motion.div
                className="section-paragraph meta-liner"
                variants={{
                  hidden: { opacity: 0, y: 20 },
                  visible: { opacity: 1, y: 0 },
                }}
                transition={{ duration: 0.5 }}
              >
                <div className="new-icon-hero">
                  <img src="/images/detail-icon/type.svg" alt="" />
                </div>
                <p className='white-color'>{projectDetail.size_price}</p>
              </motion.div>
            )}

            {projectDetail?.location && (
              <motion.div
                className="section-paragraph meta-liner"
                variants={{
                  hidden: { opacity: 0, y: 20 },
                  visible: { opacity: 1, y: 0 },
                }}
                transition={{ duration: 0.5 }}
              >
                <div className="new-icon-hero">
                  <img src="/images/detail-icon/location.svg" alt="" />
                </div>
                <p className='white-color'>{projectDetail.location}</p>
              </motion.div>
            )}
            {staticProjectDetail?.project_status && (
              <motion.div
                className="section-paragraph meta-liner"
                variants={{
                  hidden: { opacity: 0, y: 20 },
                  visible: { opacity: 1, y: 0 },
                }}
                transition={{ duration: 0.5 }}
              >
                <div className="new-icon-hero">
                  <img src="/images/detail-icon/status.svg" alt="" />
                </div>
                <p className='white-color'>{staticProjectDetail.project_status}</p>
              </motion.div>
            )}
          </motion.div>
        </motion.div>
      </div>
    </section>
  );
}
